/**
 * @generated SignedSource<<53c2b54f91ede5520883ed9f2ec56d2b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceVersionRenameButtonFragment$data = {
  readonly id: string;
  readonly version: Semver;
  readonly " $fragmentType": "WorkspaceVersionRenameButtonFragment";
};
export type WorkspaceVersionRenameButtonFragment$key = {
  readonly " $data"?: WorkspaceVersionRenameButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceVersionRenameButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceVersionRenameButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    }
  ],
  "type": "WorkspaceVersion",
  "abstractKey": null
};

(node as any).hash = "ed8eff05740aa875341c134f09a575aa";

export default node;
